var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinManHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CoinManHead") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CoinManHead",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2274866,18.8178283 C12.2262316,23.3087514 15.9891748,24.345651 18.6303734,21.1330431 C21.271572,17.9204352 21.781456,11.6743022 19.7725134,7.18337908 C17.7635708,2.69047716 14.0006275,1.65456693 11.3696266,4.86717485 C8.72842796,8.07978277 8.21854405,14.3259157 10.2274866,18.8178283",
    id: "Fill-234",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79050543,17.4846604 C6.81261399,21.954452 15.17819,24.8401258 17.8264337,21.6433388 C20.4849419,18.4455672 18.072782,10.6313082 16.0506734,6.16250119 C14.0388294,1.69270963 10.251225,0.660916338 7.59271678,3.85770339 C4.93420858,7.05547497 2.77866138,13.0148689 4.79050543,17.4846604",
    id: "Fill-235",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6477579,6.20081307 C10.6477579,6.20081307 12.0342435,15.133659 4.71441532,17 C4.71441532,17 -3.77780873,12.247678 2.03319692,3.776669 C7.1509598,-3.69069436 16,2.22021857 16,2.22021857 L10.6477579,6.20081307",
    id: "Fill-236",
    fill: "#4A3C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6209717,13 C20.6209717,13 19.5782957,8.99112619 15,7.21323242 L18.4882253,5 C18.4882253,5 22.166028,5.96776719 20.6209717,13",
    id: "Fill-237",
    fill: "#4A3C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66846367,11.8655121 C8.19146861,9.88436371 11.6207513,9.96719247 16.5528666,11.6882971 C17.309326,11.949304 18.1162161,12.0812521 18.8827616,11.9464146 C22.4734223,11.3155676 22.8667812,7.14138335 22.8667812,7.14138335 C23.5526377,4.35795175 21.5152403,3.05965908 18.4793166,2.27856461 L10.5919665,0.243481223 C6.12381289,-0.931531427 1.95824308,2.38065587 1.28247267,5.16312435 L1.09083629,5.62060879 C0.41506588,8.40404039 3.6325399,11.0844176 6.66846367,11.8655121",
    id: "Fill-238",
    fill: "#4A3C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16505845,16.6936269 C4.60389131,17.7295121 5.78325462,18.2587143 6.78891326,17.8749489 C7.80371425,17.4930601 8.26997416,16.342702 7.84028365,15.3068169 C7.40145079,14.2709317 6.22208748,13.7417295 5.20728649,14.1245566 C4.1924855,14.5073837 3.72622558,15.6577417 4.16505845,16.6936269",
    id: "Fill-239",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5958549,20.9805669 L15.5958549,20.9805669 C16.6777202,20.8038655 17.7595855,19.4694652 18,18 L14.0440885,18.6387655 C13.8146019,20.1092462 14.5030617,21.1572683 15.5958549,20.9805669",
    id: "Fill-241",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinManHead);
export default __webpack_public_path__ + "static/media/CoinManHead.de65735dedf7de85dd5c0a37ae332fa9.svg";
export { ForwardRef as ReactComponent };